import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.heading',
		defaultMessage: 'Integrations',
		description: 'Navigation group heading for integration settings items',
	},
	applicationLinksItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.application-links-item',
		defaultMessage: 'Application links',
		description: 'Navigation item which links to an application links settings page',
	},
	dvcsAccountsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.dvcs-accounts-item',
		defaultMessage: 'DVCS accounts',
		description: 'Navigation item which links to a DVCS accounts settings page',
	},
	statuspageItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.statuspage-item',
		defaultMessage: 'Statuspage',
		description: 'Navigation item which links to a statuspage settings page',
	},
	compassItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.compass-item',
		defaultMessage: 'Compass',
		description: 'Navigation item which links to the Compass product settings page',
	},
	confluenceItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.integrations-section.confluence-item',
		defaultMessage: 'Confluence',
		description: 'Navigation item which links to the Confluence product settings page',
	},
});
